import * as ReactRuntime from 'react/jsx-runtime';
import type * as React from 'react';

import { localizeProps } from './runtime';

type RuntimeProps = Record<string, unknown> | null;

export const Fragment = ReactRuntime.Fragment;

export namespace JSX {
  export type ElementType = React.JSX.ElementType;
  export interface Element extends React.JSX.Element {}
  export interface ElementClass extends React.JSX.ElementClass {}
  export interface ElementAttributesProperty extends React.JSX.ElementAttributesProperty {}
  export interface ElementChildrenAttribute extends React.JSX.ElementChildrenAttribute {}
  export type LibraryManagedAttributes<C, P> = React.JSX.LibraryManagedAttributes<C, P>;
  export interface IntrinsicAttributes extends React.JSX.IntrinsicAttributes {}
  export interface IntrinsicClassAttributes<T> extends React.JSX.IntrinsicClassAttributes<T> {}
  export interface IntrinsicElements extends React.JSX.IntrinsicElements {}
}

export function jsx(type: React.ElementType, props: RuntimeProps, key?: React.Key) {
  return ReactRuntime.jsx(type, localizeProps(props), key);
}

export function jsxs(type: React.ElementType, props: RuntimeProps, key?: React.Key) {
  return ReactRuntime.jsxs(type, localizeProps(props), key);
}
